import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../../../store';
import { GaragesData, allFloorsType, GarageType } from '../types';
import merge from 'deepmerge'
import { openCloseGarage, openCloseGarages } from './garageAPI';

export interface GrageState {
    garages: GarageType[],
    status?: string,
    loading?: boolean,
    garageDoorLoading?: boolean,
    selectedGarage?: number;
}

const initialState: GrageState = {
    garages: GaragesData,
    status: 'idle',
    loading: false,
    garageDoorLoading: false,
    selectedGarage: 0

};

export const handleCloseOpenGaragesAsync = createAsyncThunk(
    'garage/openCloseGarages',
    async (closeAll: boolean, { getState }) => {
        const { garages } = getState() as { garages: GrageState };

        const response = await openCloseGarages(garages.garages, closeAll);
        return response.data;
    }
);
export const openCloseGarageAsync = createAsyncThunk(
    'garage/openCloseGarage',
    async (garageId: number, { getState }) => {
        const { garages } = getState() as { garages: GrageState };

        const response = await openCloseGarage(garages.garages, garageId);
        return response.data;
    }
);

export const GrageSlicer = createSlice({
    name: 'garages',
    initialState,
    reducers: {
        lockUnLockDoor: (state, action: PayloadAction<{ doorId: number, isLocked: boolean }>) => {
            state.garageDoorLoading = true

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(handleCloseOpenGaragesAsync.pending, (state) => {
                state.loading = true
                state.status = 'loading';
            })
            .addCase(handleCloseOpenGaragesAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false
                state.garages = action.payload
            })
            .addCase(handleCloseOpenGaragesAsync.rejected, (state) => {
                state.status = 'failed';
            }).addCase(openCloseGarageAsync.pending, (state, action) => {
                state.garageDoorLoading = true
                state.selectedGarage = action?.meta?.arg
            }).addCase(openCloseGarageAsync.fulfilled, (state, action) => {
                state.garageDoorLoading = false
                state.garages = action.payload
            })
    },

});

export const { lockUnLockDoor } = GrageSlicer.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectGaragesData = (state: RootState) => state.garages.garages;
export const selectGarageState = (state: RootState) => state.garages;


export default GrageSlicer.reducer;
